import { useExportAction } from "@/action/use-export-action";
import { useExpertData, useExpertsData } from "@/data/use-experts-data";
import { useKitData } from "@/data/use-kits-data";
import { useGroupUuid } from "@/hooks/use-group-uuid";
import { kitLabel } from "@/lib/kit-label";
import { Kit } from "@/types/types";
import { KitQuickSettingsUI } from "./KitQuickSettingsUI";

type ExpertKitQuickSettingsProps = {
  kit: Kit;
};

export const ExpertKitQuickSettings = ({
  kit,
}: ExpertKitQuickSettingsProps) => {
  const groupUuid = useGroupUuid();
  const { updateKit } = useKitData(groupUuid, kit.uuid);
  const { experts } = useExpertsData(groupUuid, kit.uuid);
  const expertUuid = experts[0]?.uuid;
  const { updateExpert } = useExpertData(groupUuid, kit.uuid, expertUuid);
  const { exportKitBundle } = useExportAction();

  return (
    <KitQuickSettingsUI
      kit={kit}
      onNameChange={async (name) => {
        const result = await updateKit({ name });
        if (!result.error && expertUuid) await updateExpert({ name });
        return result;
      }}
      onExport={() =>
        exportKitBundle(
          `${kitLabel(kit)} - ${kit.name}`,
          { format: "docx", includeFiles: true },
          kit.uuid,
        )
      }
    />
  );
};
